import React, { useState, useEffect } from 'react';
import { useResizableSidebar } from '../hooks/useResizableSidebar';
import JobFilters from './JobFilters';
import './Sidebar.css';

interface SidebarProps {
  onFilterChange: (filters: any) => void;
  filters: any;
  darkMode: boolean;
  jobs: any[];
  isOpen?: boolean;
  onToggle?: () => void;
  selectedLocation?: {
    city: string;
    country: string;
    costOfLiving: number;
    averageSalary: number;
  } | null;
  onLoginRequired?: (action: string) => void;
  onJobClick?: (job: any) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ 
  onFilterChange, 
  filters, 
  darkMode, 
  jobs, 
  isOpen = true, 
  onToggle,
  selectedLocation,
  onLoginRequired,
  onJobClick
}) => {
  const [isMobile, setIsMobile] = useState(false);
  
  // Check if we're on mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Use the resizable sidebar hook only on non-mobile
  const sidebarRef = useResizableSidebar({
    minWidth: isMobile ? 320 : window.innerWidth <= 1024 ? 280 : 320,
    maxWidth: isMobile ? 480 : window.innerWidth <= 1024 ? 350 : window.innerWidth >= 1440 ? 520 : 480,
    defaultWidth: isMobile ? 380 : window.innerWidth <= 1024 ? 300 : window.innerWidth >= 1440 ? 420 : 380
  });
  
  // Render JobFilters with integrated JobList
  return (
    <JobFilters 
      onFilterChange={onFilterChange} 
      filters={filters} 
      darkMode={darkMode}
      jobs={jobs}
      selectedLocation={selectedLocation}
      onLoginRequired={onLoginRequired}
      onJobClick={onJobClick}
    />
  );
};

export default Sidebar;